/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import get from 'lodash/get';
import MonkeyPatch from './monkey';

export const formats = {
  date: {
    fullDateTimeUtc: {
      year: 'numeric',
      day: '2-digit',
      month: 'short',
      weekday: 'long',
    },
    fullDate: {
      year: 'numeric',
      day: 'numeric',
      month: 'long',
      weekday: 'long',
    },
  },
};

const LanguageProvider = ({ locale, children, messages }) => {
  const localeMessages = messages[locale] || messages[locale.split('-')[0]];
  return (
    <IntlProvider key={locale} locale={locale} messages={localeMessages}>
      <MonkeyPatch>
        {React.Children.only(children)}
      </MonkeyPatch>
    </IntlProvider>
  );
};

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  children: PropTypes.element.isRequired,
};

const mapStateToProps = (state) => ({ locale: get(state, 'language.locale') });

export default connect(mapStateToProps)(LanguageProvider);
